import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TimeOffRequestListI } from './type'

interface UserListState {
    timeoffRequestsList: TimeOffRequestListI[] | null
}

const initialState: UserListState = {
    timeoffRequestsList: null,
}

const teacherTimeOffRequestsSlice = createSlice({
    name: 'timeoffRequests',
    initialState,
    reducers: {
        setTimeoffRequestsList(
            state,
            action: PayloadAction<TimeOffRequestListI[]>
        ) {
            state.timeoffRequestsList = action.payload
        },
        deleteTimeoffRequestsList(state, action: PayloadAction<string>) {
            if (state.timeoffRequestsList) {
                state.timeoffRequestsList = state.timeoffRequestsList.filter(
                    (timeoffRequestsList) =>
                        timeoffRequestsList.id !== action.payload
                )
            }
        },
    },
})

export const { setTimeoffRequestsList, deleteTimeoffRequestsList } =
    teacherTimeOffRequestsSlice.actions

export default teacherTimeOffRequestsSlice.reducer
